import { ultraMarine } from '@cogneed/react-utils';
import { styled, Box } from '@mui/material';

const StyledBox = styled(Box)({
  display: 'flex',
  gap: 4,
  textDecoration: 'underline',
  color: ultraMarine[500],
  alignItems: 'center',
  cursor: 'pointer',
  '&.disabled': {
    cursor: 'not-allowed',
  },

  '&:hover': {
    textDecoration: 'underline',
    color: ultraMarine[700],
  },
  '& div': {
    height: 'min-content',
  },

  '& svg': {
    fontSize: 16,
    display: 'block',
  },

  '& strong': {
    display: 'block',
    '::before': {
      content: 'open-quote',
    },
    '::after': {
      content: 'close-quote',
    },
  },
  '& .deleted': {
    textDecoration: 'line-through',
  },
});

export default StyledBox;
